// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const num_POSTS_AND_ANSWERS_IN_LAST_WEEK = ["%(num)s \u010dlovek prispel za t\u00fd\u017ede\u0148", "%(num)s \u013eudia prispeli za t\u00fd\u017ede\u0148", "%(num)s \u013eud\u00ed prispelo za t\u00fd\u017ede\u0148"];
